import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Row, Col, Card } from "react-bootstrap";
import { toast } from "sonner";
import {
  addNewKbArticle,
  fetchKbArticlesList,
  updateExistingKbArticle,
  uploadKbImage,
  fetchKbCategoriesList,
  fetchKbArticleDetails,
  uploadKbInlineImage,
  verifyKBSlug,
} from "../../services/axios/apiManager";
import { Formik } from "formik";
import { kbValidationSchema } from "./kbValidations";
import { useNavigate, useParams } from "react-router-dom";
import { baseURL } from "../../services/axios/eps";
import { handleErrors } from "../../services/dataManager";
import LoadingSpinner from "../../Components/spinner";
import DashboardLayout from "../DashboardLayout";
import $ from "jquery";
import "summernote/dist/summernote-lite.css";
import "summernote/dist/summernote-lite.js";
import { useAppContext } from "../../services/context";
import { SwitchButtonMedium } from "../../Components/switchButton";
import AddKbCategoryModal from "./addKbCategoryModal";
// import { SwitchButtonMedium } from "../../Components/switchButton";

const AddEditKbArticle = () => {
  const navigate = useNavigate();
  const { state } = useAppContext();
  const { user } = state;
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [articleData, setArticleData] = useState(null);
  const [categories, setCategories] = useState([]);
  const [showCatModal, setShowCatModal] = useState(false);

  const editorRef = useRef(null);
  const isSummernoteInited = useRef(false);
  const formikRef = useRef(null);

  const getKbCategoriesList = async () => {
    try {
      const catRes = await fetchKbCategoriesList();
      if (catRes?.data?.success) {
        setCategories(catRes.data.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const verifySlugIsUnique = async (slug) => {
    const res = await verifyKBSlug({ slug });
    if (res?.data?.success) {
      return res.data.data;
    }
    return false;
  };
  const fetchData = async () => {
    setInitialLoading(true);
    try {
      const catRes = await fetchKbCategoriesList();

      if (catRes?.data?.success) setCategories(catRes.data.data);

      if (id) {
        const kbRes = await fetchKbArticleDetails(id);
        if (kbRes?.data?.success) {
          setArticleData(kbRes.data.data);
        } else {
          toast.error("Failed to fetch article details");
          navigate("/KbManagement");
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setInitialLoading(false);
    }
  };

  const refreshCategories = async () => {
    const catRes = await fetchKbCategoriesList();
    if (catRes?.data?.success) setCategories(catRes.data.data);
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  useEffect(() => {
    if (!initialLoading && editorRef.current && !isSummernoteInited.current) {
      $(editorRef.current).summernote({
        placeholder: "Enter article content...",
        tabsize: 2,
        height: 400,
        toolbar: [
          ["style", ["style"]],
          ["font", ["bold", "underline", "clear"]],
          ["color", ["color"]],
          ["para", ["ul", "ol", "paragraph"]],
          ["table", ["table"]],
          ["insert", ["link", "picture", "video"]],
          ["view", ["fullscreen", "codeview", "help"]],
        ],
        callbacks: {
          onChange: function (contents) {
            if (formikRef.current) {
              formikRef.current.setFieldValue("content", contents);
            }
          },
          onImageUpload: function (files) {
            for (let i = 0; i < files.length; i++) {
              const file = files[i];
              const formData = new FormData();
              formData.append("image", file);
              uploadKbInlineImage(formData)
                .then((res) => {
                  if (res?.data?.success) {
                    const url = `${baseURL}/uploads/file/${res.data.url}`;
                    $(editorRef.current).summernote("insertImage", url);
                  } else {
                    toast.error("Failed to upload inline image");
                  }
                })
                .catch((err) => {
                  console.error("Error uploading image:", err);
                  toast.error("Error uploading image");
                });
            }
          },
        },
      });
      isSummernoteInited.current = true;

      $(".note-editable").css({
        "background-color": "transparent",
        color: "#fff",
        "min-height": "400px",
      });
      if ($("#summernote-custom-styles").length === 0) {
        $("<style id='summernote-custom-styles'>")
          .prop("type", "text/css")
          .html(
            `
                  .note-editable ul {
                    list-style-type: disc !important;
                    padding-left: 40px !important;
                  }
                  .note-editable ol {
                    list-style-type: decimal !important;
                    padding-left: 40px !important;
                  }
                  .note-editable li {
                    display: list-item !important;
                  }
                `,
          )
          .appendTo("head");
      }
      $(".note-toolbar").addClass("summernote-toolbar");

      if (articleData?.content) {
        $(editorRef.current).summernote("code", articleData.content);
      }
    }

    return () => {
      if (isSummernoteInited.current) {
        $(editorRef.current).summernote("destroy");
        isSummernoteInited.current = false;
      }
    };
  }, [initialLoading, articleData]);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleAddEditKbArticle = async (data) => {
    setLoading(true);

    if (!id || data.slug !== articleData?.slug) {
      const isSlugTaken = await verifySlugIsUnique(data.slug);
      if (isSlugTaken) {
        toast.error("Blog slug must be unique", { duration: 2000 });
        if (formikRef.current) {
          formikRef.current.setFieldError("slug", "Slug must be unique");
        }
        setLoading(false);
        return;
      }
    }

    let kbId = id;
    let success = false;
    let newKbId = null;

    // Ensure numeric values
    const payload = { ...data };

    if (kbId) {
      const editResponse = await updateExistingKbArticle({
        id: kbId,
        ...payload,
      });
      if (editResponse?.data?.success) {
        success = true;
        toast.success("KB Article has been updated");
      } else {
        handleErrors(editResponse, navigate, "Update KB Article:");
      }
    } else {
      const addResponse = await addNewKbArticle(payload);
      if (addResponse?.data?.success) {
        success = true;
        newKbId = addResponse.data.data.id;
        toast.success("New KB Article has been added");
      } else {
        handleErrors(addResponse, navigate, "Add KB Article:");
      }
    }

    if (success && selectedFile) {
      const formData = new FormData();
      formData.append("image", selectedFile);
      const uploadRes = await uploadKbImage(kbId || newKbId, formData);
      if (!uploadRes?.data?.success) {
        toast.error("Image upload failed");
      }
    }

    setLoading(false);
    if (success) {
      navigate("/KbManagement");
    }
  };

  if (initialLoading) {
    return (
      <DashboardLayout>
        <div className="d-flex justify-content-center align-items-center vh-100">
          <LoadingSpinner size="lg" />
        </div>
      </DashboardLayout>
    );
  }
  const getfeaturedState = () => {
    if (articleData) {
      return articleData?.is_featured === 1 ? 1 : 0;
    } else {
      return 1;
    }
  };
  return (
    <DashboardLayout>
      <div className="container py-4">
        <Card className="bg-dark text-light border-secondary shadow">
          <Card.Header className="border-secondary d-flex justify-content-between align-items-center">
            <h3 className="text-success mb-0">
              {id ? "Edit KB Article" : "Add New KB Article"}
            </h3>
            <div>
              <Button
                variant="outline-success"
                className="me-2"
                onClick={() => setShowCatModal(true)}
              >
                Add New Category
              </Button>
              <Button
                variant="outline-secondary"
                onClick={() => navigate("/KbManagement")}
              >
                Back to List
              </Button>
            </div>
          </Card.Header>
          <Card.Body>
            {articleData?.image && (
              <div
                style={{
                  height: "300px",
                  marginBottom: "20px",
                  overflow: "hidden",
                  borderRadius: "8px",
                }}
              >
                <img
                  crossOrigin="anonymous"
                  src={`${baseURL}/uploads/file/${articleData?.image}`}
                  alt=""
                  className="w-100 h-100 object-fit-cover"
                />
              </div>
            )}
            <Formik
              innerRef={formikRef}
              initialValues={{
                title: articleData?.title || "",
                slug: articleData?.slug || "",
                summary: articleData?.summary || "",
                content: articleData?.content || "",
                category_id: articleData?.category_id || "",
                meta_title: articleData?.meta_title || "",
                meta_description: articleData?.meta_description || "",
                meta_keywords: articleData?.meta_keywords || "",
                is_featured: getfeaturedState(),
              }}
              enableReinitialize={true}
              validationSchema={kbValidationSchema}
              onSubmit={handleAddEditKbArticle}
            >
              {({
                handleChange,
                handleSubmit,
                values,
                errors,
                touched,
                setFieldValue,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="kbCategory">
                    <Form.Label>Category</Form.Label>
                    <Form.Select
                      className="bg-dark text-light border-secondary"
                      value={values.category_id}
                      onChange={handleChange("category_id")}
                    >
                      <option value="">Select Category</option>
                      {categories?.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.name}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.category_id && touched.category_id && (
                      <span className="text-danger">{errors.category_id}</span>
                    )}
                  </Form.Group>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="kbTitle">
                        <Form.Label>Title</Form.Label>
                        <Form.Control
                          type="text"
                          className="bg-dark text-light border-secondary"
                          value={values.title}
                          onChange={(e) => {
                            handleChange("title")(e);
                            // if (!id) {
                            const slug = e.target.value
                              .toLowerCase()
                              .trim()
                              .replace(/ /g, "-")
                              .replace(/[^\w-]+/g, "");
                            setFieldValue("slug", slug);
                            // }
                          }}
                        />
                        {errors.title && touched.title && (
                          <span className="text-danger">{errors.title}</span>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="kbSlug">
                        <Form.Label>Slug</Form.Label>
                        <Form.Control
                          type="text"
                          className="bg-dark text-light border-secondary"
                          value={values.slug}
                          onChange={handleChange("slug")}
                        />
                        {errors.slug && touched.slug && (
                          <span className="text-danger">{errors.slug}</span>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-3" controlId="kbImage">
                    <Form.Label>
                      {id ? "Change Featured Image" : "Featured Image"}
                    </Form.Label>
                    <Form.Control
                      type="file"
                      className="bg-dark text-light border-secondary"
                      onChange={handleFileChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="kbSummary">
                    <Form.Label>Summary</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      className="bg-dark text-light border-secondary"
                      value={values.summary}
                      onChange={handleChange("summary")}
                    />
                    {errors.summary && touched.summary && (
                      <span className="text-danger">{errors.summary}</span>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="kbContent">
                    <Form.Label>Content</Form.Label>
                    <div
                      id="kbContent"
                      ref={editorRef}
                      className="bg-dark text-light border-secondary rounded"
                    />
                    {errors.content && touched.content && (
                      <span className="text-danger">{errors.content}</span>
                    )}
                  </Form.Group>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="metaTitle">
                        <Form.Label>Meta Title</Form.Label>
                        <Form.Control
                          type="text"
                          className="bg-dark text-light border-secondary"
                          value={values.meta_title}
                          onChange={handleChange("meta_title")}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="metaDescription">
                        <Form.Label>Meta Description</Form.Label>
                        <Form.Control
                          type="text"
                          className="bg-dark text-light border-secondary"
                          value={values.meta_description}
                          onChange={handleChange("meta_description")}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <Form.Group className="mb-3" controlId="metaTitle">
                        <Form.Label>Meta Keywords (Comma separated)</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={2}
                          name="meta_keywords"
                          value={values.meta_keywords}
                          onChange={handleChange}
                          className="bg-dark text-light border-secondary"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <div className="container-fluid mt-4">
                        <div className="d-flex align-items-center">
                          <SwitchButtonMedium
                            isOn={values.is_featured === 1}
                            onClick={() =>
                              setFieldValue(
                                "is_featured",
                                values.is_featured === 1 ? 0 : 1,
                              )
                            }
                            color={"#00af43ff"}
                          />
                          <span className="mx-2">Featured Article</span>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <div className="d-flex justify-content-end mt-4">
                    {loading && <LoadingSpinner size="md" className="me-2" />}
                    <Button
                      variant="secondary"
                      className="me-2"
                      onClick={() => navigate("/KbManagement")}
                    >
                      Cancel
                    </Button>
                    <Button variant="success" type="submit" disabled={loading}>
                      {id ? "Save Changes" : "Create Article"}
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Card.Body>
        </Card>
        <AddKbCategoryModal
          show={showCatModal}
          onHide={() => setShowCatModal(false)}
          onSuccess={() => {
            getKbCategoriesList();
          }}
        />
      </div>
    </DashboardLayout>
  );
};

export default AddEditKbArticle;
